import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolbarModule } from '@components/toolbar';
import { ButtonModule } from '@components/button';
import { LoadingModule } from '@components/loading';
import { CsIconModule } from '@components/icon';
import { NoticeComponent } from './notice.component';
import {DirectivesModule} from '@directives/directives.module';

@NgModule({
  imports: [
    CommonModule,
    ToolbarModule,
    ButtonModule,
    LoadingModule,
    CsIconModule,
    DirectivesModule,
  ],
  declarations: [NoticeComponent],
  exports: [],
})
export class NoticeModule {}
